export const NEXT = "next";
export const PREVIOUS = "previous";
export const FIRST = "first";
export const PRANA = "Prana";
export const ASC = "ASC";
export const DESC = "DESC";
//export const RECEINGDEFAULTCOLUMN = "ReceivingDate";
export const POSTATUSACCEPTED = "Accepted";
export const SELECT = "Select";
export const SortedColumnName = "ReceiveTime";
export const GMSortedColumnName = "CreatedDate";